import type { CreativesConfig } from '@ad-lucy/config/creatives';
import { useCallback } from 'react';

import { useConfiguration } from './useConfiguration';
import { useSearchParams } from './useSearchParams';

export function useLiveRendering() {
  const { previewMode } = useSearchParams();
  const enabled = previewMode === 'liveRendering';

  const configModifier = useCallback(
    <T extends CreativesConfig>(config: T): T => {
      if (enabled) {
        return {
          ...config,
          settings: {
            ...config.settings,
            autoplay: false,
            startupAnimation: false,
            forceVideoOnDemand: true,
          },
        };
      }

      return config;
    },
    [enabled],
  );

  const configuration = useConfiguration();

  return {
    enabled,
    configModifier,
    ...configuration,
  };
}
